/*
Licensed Materials - Property of IBM
694906H
(c) Copyright IBM Corp.  2020 All Rights Reserved

US Government Users Restricted Rights - Use, duplication or disclosure restricted
by GSA ADP Schedule Contract with IBM Corp.
*/

import * as CSS from 'csstype';

type Props = {
  errorRed: CSS.Property.Color;
  btnPurple: CSS.Property.Color;
};

declare global {
  interface EXOComponentStyles {
    generalErrorPage?: Partial<Props>;
  }
}

export default (props: EXOThemeProps): Props => {
  return {
    errorRed: '#da1e28',
    btnPurple: '#714e9d',
    ...props.theme?.byComponent?.generalErrorPage
  };
};
